import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
// import { FreeMode } from 'swiper';

import 'swiper/css';
import './styles.scss';

interface Props {
  children: JSX.Element[];
}

const CustomChipsSlider = ({ children } : Props) => (
  <Swiper
    slidesPerView="auto"
    spaceBetween={8}
    grabCursor
    loop={false}
    className="customChipsSlider"
  >
    { React.Children.map(children, (child) => (
      <SwiperSlide>{child}</SwiperSlide>
    )) }
  </Swiper>
);

export default CustomChipsSlider;
